// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/ur_browser_app_rewamp.eot?mhq6jy", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/ur_browser_app_rewamp.ttf?mhq6jy", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/ur_browser_app_rewamp.woff?mhq6jy", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/ur_browser_app_rewamp.svg?mhq6jy", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#ur_browser_app_rewamp" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'ur_browser_app_rewamp';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon_"], [class*=" icon_"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'ur_browser_app_rewamp' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon_zoom2:before {
  content: "\\e100";
}
.icon_call:before {
  content: "\\e101";
}
.icon_chat:before {
  content: "\\e102";
}
.icon_contact:before {
  content: "\\e103";
}
.icon_down-arrow:before {
  content: "\\e104";
}
.icon_edit:before {
  content: "\\e105";
}
.icon_exclamatric:before {
  content: "\\e106";
}
.icon_mail:before {
  content: "\\e107";
}
.icon_meet:before {
  content: "\\e108";
}
.icon_message:before {
  content: "\\e109";
}
.icon_plus:before {
  content: "\\e10a";
}
.icon_reply:before {
  content: "\\e10b";
}
.icon_ribbon:before {
  content: "\\e10c";
}
.icon_star:before {
  content: "\\e10d";
}
.icon_task:before {
  content: "\\e10e";
}
.icon_zoom:before {
  content: "\\e10f";
}
.icon_ticknote:before {
  content: "\\e110";
}
.icon_tick:before {
  content: "\\e111";
}
.icon_taskfill:before {
  content: "\\e112";
}
.icon_wifi:before {
  content: "\\e113";
}
.icon_attach:before {
  content: "\\e114";
}
.icon_belloutline:before {
  content: "\\e115";
}
.icon_bellstroke:before {
  content: "\\e116";
}
.icon_bold:before {
  content: "\\e117";
}
.icon_bullet:before {
  content: "\\e118";
}
.icon_close:before {
  content: "\\e119";
}
.icon_pin:before {
  content: "\\e11a";
}
.icon_datepick:before {
  content: "\\e11b";
}
.icon_delete:before {
  content: "\\e11c";
}
.icon_doubleclick:before {
  content: "\\e11d";
}
.icon_downarrow2:before {
  content: "\\e11e";
}
.icon_sendoutline:before {
  content: "\\e11f";
}
.icon_editfill:before {
  content: "\\e120";
}
.icon_editpen:before {
  content: "\\e121";
}
.icon_event:before {
  content: "\\e122";
}
.icon_strokearrowright:before {
  content: "\\e123";
}
.icon_gif:before {
  content: "\\e124";
}
.icon_image:before {
  content: "\\e125";
}
.icon_info:before {
  content: "\\e126";
}
.icon_italic:before {
  content: "\\e127";
}
.icon_link:before {
  content: "\\e128";
}
.icon_linkrotate:before {
  content: "\\e129";
}
.icon_meetfill:before {
  content: "\\e12a";
}
.icon_microphone:before {
  content: "\\e12b";
}
.icon_note:before {
  content: "\\e12c";
}
.icon_numberlist:before {
  content: "\\e12d";
}
.icon_outlineleftarrow:before {
  content: "\\e12e";
}
.icon_profile:before {
  content: "\\e12f";
}
.icon_overflow:before {
  content: "\\e130";
}
.icon_qutation:before {
  content: "\\e131";
}
.icon_savechatsill:before {
  content: "\\e132";
}
.icon_sendarrow:before {
  content: "\\e133";
}
.icon_sticker:before {
  content: "\\e134";
}
.icon_smily:before {
  content: "\\e135";
}
.icon_strike:before {
  content: "\\e136";
}
.icon_strokerightarrow:before {
  content: "\\e137";
}
.icon_anger:before {
  content: "\\e138";
}
.icon_happy:before {
  content: "\\e139";
}
.icon_confussion:before {
  content: "\\e13a";
}
.icon_energy:before {
  content: "\\e13b";
}
.icon_smile:before {
  content: "\\e13c";
}
.icon_strong:before {
  content: "\\e13d";
}
.icon_sad:before {
  content: "\\e13e";
}
.icon_chatfill:before {
  content: "\\e13f";
}
.icon_checked:before {
  content: "\\e140";
}
.icon_checkedround:before {
  content: "\\e141";
}
.icon_closefill:before {
  content: "\\e142";
}
.icon_cloud:before {
  content: "\\e143";
}
.icon_play:before {
  content: "\\e144";
}
.icon_record:before {
  content: "\\e145";
}
.icon_replyfill:before {
  content: "\\e146";
}
.icon_ribbonfill:before {
  content: "\\e147";
}
.icon_lock:before {
  content: "\\e148";
}
.icon_starfill:before {
  content: "\\e149";
}
.icon_taskfill1:before {
  content: "\\e14a";
}
.icon_tickfill:before {
  content: "\\e14b";
}
.icon_drive:before {
  content: "\\e14c";
}
.icon_dropbox:before {
  content: "\\e14d";
}
.icon_eventfill:before {
  content: "\\e14e";
}
.icon_eye:before {
  content: "\\e14f";
}
.icon_fillnotification:before {
  content: "\\e150";
}
.icon_clock:before {
  content: "\\e151";
}
.icon_closerec:before {
  content: "\\e152";
}
.icon_computer:before {
  content: "\\e153";
}
.icon_datenote:before {
  content: "\\e154";
}
.icon_flagoutline:before {
  content: "\\e155";
}
.icon_food:before {
  content: "\\e156";
}
.icon_gift:before {
  content: "\\e157";
}
.icon_handtwo:before {
  content: "\\e158";
}
.icon_leaf:before {
  content: "\\e159";
}
.icon_light:before {
  content: "\\e15a";
}
.icon_outlinenotification:before {
  content: "\\e15b";
}
.icon_plane:before {
  content: "\\e15c";
}
.icon_ring:before {
  content: "\\e15d";
}
.icon_run:before {
  content: "\\e15e";
}
.icon_setting:before {
  content: "\\e15f";
}
.icon_tickrec:before {
  content: "\\e160";
}
.icon_chatbox:before {
  content: "\\e161";
}
.icon_datenotefill:before {
  content: "\\e162";
}
.icon_notification:before {
  content: "\\e163";
}
.icon_overflow-H:before {
  content: "\\e164";
}
.icon_reciver:before {
  content: "\\e165";
}
.icon_searchlft:before {
  content: "\\e166";
}
.icon_searchrgt:before {
  content: "\\e167";
}
.icon_applecommand:before {
  content: "\\e168";
}
.icon_recordclose:before {
  content: "\\e169";
}
.icon_recordtick:before {
  content: "\\e16a";
}
.icon_pausebar:before {
  content: "\\e16b";
}
.icon_blockdelete:before {
  content: "\\e16c";
}
.icon_Downloadstroke:before {
  content: "\\e16d";
}
.icon_Strokeleftarrow:before {
  content: "\\e16e";
}
.icon_Preview-plus:before {
  content: "\\e16f";
}
.icon_Preview-minus:before {
  content: "\\e170";
}
.icon_Folderoutline:before {
  content: "\\e171";
}
.icon_Folderfill:before {
  content: "\\e172";
}
.icon_noteactive:before {
  content: "\\e173";
}
.icon_linkactive:before {
  content: "\\e174";
}
.icon_eventactive:before {
  content: "\\e175";
}
.icon_Add-call:before {
  content: "\\e176";
}
.icon_Contactfill:before {
  content: "\\e177";
}
.icon_flipfill:before {
  content: "\\e178";
}
.icon_flipoutline:before {
  content: "\\e179";
}
.icon_holdfill:before {
  content: "\\e17a";
}
.icon_holdoutline:before {
  content: "\\e17b";
}
.icon_Income-call:before {
  content: "\\e17c";
}
.icon_Outgoing:before {
  content: "\\e17d";
}
.icon_Missedcall:before {
  content: "\\e17e";
}
.icon_Keypadfill:before {
  content: "\\e17f";
}
.icon_Keypadoutline:before {
  content: "\\e180";
}
.icon_Notificationsolid:before {
  content: "\\e181";
}
.icon_parkcall:before {
  content: "\\e182";
}
.icon_parkcallfill:before {
  content: "\\e183";
}
.icon_receiverfill:before {
  content: "\\e184";
}
.icon_recordoutline:before {
  content: "\\e185";
}
.icon_recordoutlinefill:before {
  content: "\\e186";
}
.icon_summary:before {
  content: "\\e187";
}
.icon_transcribe:before {
  content: "\\e188";
}
.icon_transfer-fill:before {
  content: "\\e189";
}
.icon_transferoutline:before {
  content: "\\e18a";
}
.icon_transscript:before {
  content: "\\e18b";
}
.icon_Unmute:before {
  content: "\\e18c";
}
.icon_popout:before {
  content: "\\e18d";
}
.icon_popin:before {
  content: "\\e18e";
}
.icon_expandarrow:before {
  content: "\\e18f";
}
.icon_Recordcalls:before {
  content: "\\e190";
}
.icon_Newdoc:before {
  content: "\\e191";
}
.icon_copydoc:before {
  content: "\\e192";
}
.icon_stop:before {
  content: "\\e193";
}
.icon_timer:before {
  content: "\\e194";
}
.icon_Calendar:before {
  content: "\\e195";
}
.icon_Home:before {
  content: "\\e196";
}
.icon_Lockoutline:before {
  content: "\\e197";
}
.icon_Message-outline:before {
  content: "\\e198";
}
.icon_Natural:before {
  content: "\\e199";
}
.icon_Profile-group:before {
  content: "\\e19a";
}
.icon_Profile-outline:before {
  content: "\\e19b";
}
.icon_Van:before {
  content: "\\e19c";
}
.icon_Password:before {
  content: "\\e19d";
}
.icon_Viewpassword:before {
  content: "\\e19e";
}
.icon_Volume:before {
  content: "\\e19f";
}
.icon_Volumemax:before {
  content: "\\e1a0";
}
.icon_profileupload:before {
  content: "\\e1a1";
}
.icon_Like:before {
  content: "\\e1a2";
}
.icon_uparrow:before {
  content: "\\e1a3";
}
.icon_callfill:before {
  content: "\\e1a4";
}
.icon_filter:before {
  content: "\\e1a5";
}
.icon_translation:before {
  content: "\\e1a6";
}
.icon_location:before {
  content: "\\e1a7";
}
.icon_listview:before {
  content: "\\e1a8";
}
.icon_minimize:before {
  content: "\\e1a9";
}
.icon_Bulletsquare:before {
  content: "\\e1aa";
}
.icon_Fillpassword:before {
  content: "\\e1ab";
}
.icon_sortup:before {
  content: "\\e1ac";
}
.icon_User-outline:before {
  content: "\\e1ad";
}
.icon_addcalander:before {
  content: "\\e1ae";
}
.icon_sortdown:before {
  content: "\\e1af";
}
.icon_Script:before {
  content: "\\e1b0";
}
.icon_failedfill:before {
  content: "\\e1b1";
}
.icon_primarymeet:before {
  content: "\\e1b2";
}
.icon_Callfill2:before {
  content: "\\e1b3";
}
.icon_Profileselect:before {
  content: "\\e1b4";
}
.icon_profile-outline:before {
  content: "\\e1b5";
}
.icon_notificationnew:before {
  content: "\\e1b6";
}
.icon_singleclick:before {
  content: "\\e1b7";
}
.icon_globe:before {
  content: "\\e1b8";
}
.icon_app:before {
  content: "\\e1b9";
}
.icon_profilestamp:before {
  content: "\\e1ba";
}
.icon_mikeoutline:before {
  content: "\\e1bb";
}
.icon_downarrow:before {
  content: "\\e1bc";
}
.icon_recordleftpanel:before {
  content: "\\e1bd";
}
.icon_transcript:before {
  content: "\\e1be";
}
.icon_transcriptactive:before {
  content: "\\e1bf";
}
.icon_chatdashboard:before {
  content: "\\e1c0";
}
.icon_receiverdial:before {
  content: "\\e1c1";
}
.icon_dialplus:before {
  content: "\\e1c2";
}
.icon_unarchivefull:before {
  content: "\\e1c3";
}
.icon_unsaved:before {
  content: "\\e1c4";
}


`, "",{"version":3,"sources":["webpack://./src/styles/style-fonts.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,6CAAmD;EACnD;;;yDAGmF;EACnF,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,+CAA+C;EAC/C,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'ur_browser_app_rewamp';\n  src:  url('fonts/ur_browser_app_rewamp.eot?mhq6jy');\n  src:  url('fonts/ur_browser_app_rewamp.eot?mhq6jy#iefix') format('embedded-opentype'),\n    url('fonts/ur_browser_app_rewamp.ttf?mhq6jy') format('truetype'),\n    url('fonts/ur_browser_app_rewamp.woff?mhq6jy') format('woff'),\n    url('fonts/ur_browser_app_rewamp.svg?mhq6jy#ur_browser_app_rewamp') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon_\"], [class*=\" icon_\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'ur_browser_app_rewamp' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon_zoom2:before {\n  content: \"\\e100\";\n}\n.icon_call:before {\n  content: \"\\e101\";\n}\n.icon_chat:before {\n  content: \"\\e102\";\n}\n.icon_contact:before {\n  content: \"\\e103\";\n}\n.icon_down-arrow:before {\n  content: \"\\e104\";\n}\n.icon_edit:before {\n  content: \"\\e105\";\n}\n.icon_exclamatric:before {\n  content: \"\\e106\";\n}\n.icon_mail:before {\n  content: \"\\e107\";\n}\n.icon_meet:before {\n  content: \"\\e108\";\n}\n.icon_message:before {\n  content: \"\\e109\";\n}\n.icon_plus:before {\n  content: \"\\e10a\";\n}\n.icon_reply:before {\n  content: \"\\e10b\";\n}\n.icon_ribbon:before {\n  content: \"\\e10c\";\n}\n.icon_star:before {\n  content: \"\\e10d\";\n}\n.icon_task:before {\n  content: \"\\e10e\";\n}\n.icon_zoom:before {\n  content: \"\\e10f\";\n}\n.icon_ticknote:before {\n  content: \"\\e110\";\n}\n.icon_tick:before {\n  content: \"\\e111\";\n}\n.icon_taskfill:before {\n  content: \"\\e112\";\n}\n.icon_wifi:before {\n  content: \"\\e113\";\n}\n.icon_attach:before {\n  content: \"\\e114\";\n}\n.icon_belloutline:before {\n  content: \"\\e115\";\n}\n.icon_bellstroke:before {\n  content: \"\\e116\";\n}\n.icon_bold:before {\n  content: \"\\e117\";\n}\n.icon_bullet:before {\n  content: \"\\e118\";\n}\n.icon_close:before {\n  content: \"\\e119\";\n}\n.icon_pin:before {\n  content: \"\\e11a\";\n}\n.icon_datepick:before {\n  content: \"\\e11b\";\n}\n.icon_delete:before {\n  content: \"\\e11c\";\n}\n.icon_doubleclick:before {\n  content: \"\\e11d\";\n}\n.icon_downarrow2:before {\n  content: \"\\e11e\";\n}\n.icon_sendoutline:before {\n  content: \"\\e11f\";\n}\n.icon_editfill:before {\n  content: \"\\e120\";\n}\n.icon_editpen:before {\n  content: \"\\e121\";\n}\n.icon_event:before {\n  content: \"\\e122\";\n}\n.icon_strokearrowright:before {\n  content: \"\\e123\";\n}\n.icon_gif:before {\n  content: \"\\e124\";\n}\n.icon_image:before {\n  content: \"\\e125\";\n}\n.icon_info:before {\n  content: \"\\e126\";\n}\n.icon_italic:before {\n  content: \"\\e127\";\n}\n.icon_link:before {\n  content: \"\\e128\";\n}\n.icon_linkrotate:before {\n  content: \"\\e129\";\n}\n.icon_meetfill:before {\n  content: \"\\e12a\";\n}\n.icon_microphone:before {\n  content: \"\\e12b\";\n}\n.icon_note:before {\n  content: \"\\e12c\";\n}\n.icon_numberlist:before {\n  content: \"\\e12d\";\n}\n.icon_outlineleftarrow:before {\n  content: \"\\e12e\";\n}\n.icon_profile:before {\n  content: \"\\e12f\";\n}\n.icon_overflow:before {\n  content: \"\\e130\";\n}\n.icon_qutation:before {\n  content: \"\\e131\";\n}\n.icon_savechatsill:before {\n  content: \"\\e132\";\n}\n.icon_sendarrow:before {\n  content: \"\\e133\";\n}\n.icon_sticker:before {\n  content: \"\\e134\";\n}\n.icon_smily:before {\n  content: \"\\e135\";\n}\n.icon_strike:before {\n  content: \"\\e136\";\n}\n.icon_strokerightarrow:before {\n  content: \"\\e137\";\n}\n.icon_anger:before {\n  content: \"\\e138\";\n}\n.icon_happy:before {\n  content: \"\\e139\";\n}\n.icon_confussion:before {\n  content: \"\\e13a\";\n}\n.icon_energy:before {\n  content: \"\\e13b\";\n}\n.icon_smile:before {\n  content: \"\\e13c\";\n}\n.icon_strong:before {\n  content: \"\\e13d\";\n}\n.icon_sad:before {\n  content: \"\\e13e\";\n}\n.icon_chatfill:before {\n  content: \"\\e13f\";\n}\n.icon_checked:before {\n  content: \"\\e140\";\n}\n.icon_checkedround:before {\n  content: \"\\e141\";\n}\n.icon_closefill:before {\n  content: \"\\e142\";\n}\n.icon_cloud:before {\n  content: \"\\e143\";\n}\n.icon_play:before {\n  content: \"\\e144\";\n}\n.icon_record:before {\n  content: \"\\e145\";\n}\n.icon_replyfill:before {\n  content: \"\\e146\";\n}\n.icon_ribbonfill:before {\n  content: \"\\e147\";\n}\n.icon_lock:before {\n  content: \"\\e148\";\n}\n.icon_starfill:before {\n  content: \"\\e149\";\n}\n.icon_taskfill1:before {\n  content: \"\\e14a\";\n}\n.icon_tickfill:before {\n  content: \"\\e14b\";\n}\n.icon_drive:before {\n  content: \"\\e14c\";\n}\n.icon_dropbox:before {\n  content: \"\\e14d\";\n}\n.icon_eventfill:before {\n  content: \"\\e14e\";\n}\n.icon_eye:before {\n  content: \"\\e14f\";\n}\n.icon_fillnotification:before {\n  content: \"\\e150\";\n}\n.icon_clock:before {\n  content: \"\\e151\";\n}\n.icon_closerec:before {\n  content: \"\\e152\";\n}\n.icon_computer:before {\n  content: \"\\e153\";\n}\n.icon_datenote:before {\n  content: \"\\e154\";\n}\n.icon_flagoutline:before {\n  content: \"\\e155\";\n}\n.icon_food:before {\n  content: \"\\e156\";\n}\n.icon_gift:before {\n  content: \"\\e157\";\n}\n.icon_handtwo:before {\n  content: \"\\e158\";\n}\n.icon_leaf:before {\n  content: \"\\e159\";\n}\n.icon_light:before {\n  content: \"\\e15a\";\n}\n.icon_outlinenotification:before {\n  content: \"\\e15b\";\n}\n.icon_plane:before {\n  content: \"\\e15c\";\n}\n.icon_ring:before {\n  content: \"\\e15d\";\n}\n.icon_run:before {\n  content: \"\\e15e\";\n}\n.icon_setting:before {\n  content: \"\\e15f\";\n}\n.icon_tickrec:before {\n  content: \"\\e160\";\n}\n.icon_chatbox:before {\n  content: \"\\e161\";\n}\n.icon_datenotefill:before {\n  content: \"\\e162\";\n}\n.icon_notification:before {\n  content: \"\\e163\";\n}\n.icon_overflow-H:before {\n  content: \"\\e164\";\n}\n.icon_reciver:before {\n  content: \"\\e165\";\n}\n.icon_searchlft:before {\n  content: \"\\e166\";\n}\n.icon_searchrgt:before {\n  content: \"\\e167\";\n}\n.icon_applecommand:before {\n  content: \"\\e168\";\n}\n.icon_recordclose:before {\n  content: \"\\e169\";\n}\n.icon_recordtick:before {\n  content: \"\\e16a\";\n}\n.icon_pausebar:before {\n  content: \"\\e16b\";\n}\n.icon_blockdelete:before {\n  content: \"\\e16c\";\n}\n.icon_Downloadstroke:before {\n  content: \"\\e16d\";\n}\n.icon_Strokeleftarrow:before {\n  content: \"\\e16e\";\n}\n.icon_Preview-plus:before {\n  content: \"\\e16f\";\n}\n.icon_Preview-minus:before {\n  content: \"\\e170\";\n}\n.icon_Folderoutline:before {\n  content: \"\\e171\";\n}\n.icon_Folderfill:before {\n  content: \"\\e172\";\n}\n.icon_noteactive:before {\n  content: \"\\e173\";\n}\n.icon_linkactive:before {\n  content: \"\\e174\";\n}\n.icon_eventactive:before {\n  content: \"\\e175\";\n}\n.icon_Add-call:before {\n  content: \"\\e176\";\n}\n.icon_Contactfill:before {\n  content: \"\\e177\";\n}\n.icon_flipfill:before {\n  content: \"\\e178\";\n}\n.icon_flipoutline:before {\n  content: \"\\e179\";\n}\n.icon_holdfill:before {\n  content: \"\\e17a\";\n}\n.icon_holdoutline:before {\n  content: \"\\e17b\";\n}\n.icon_Income-call:before {\n  content: \"\\e17c\";\n}\n.icon_Outgoing:before {\n  content: \"\\e17d\";\n}\n.icon_Missedcall:before {\n  content: \"\\e17e\";\n}\n.icon_Keypadfill:before {\n  content: \"\\e17f\";\n}\n.icon_Keypadoutline:before {\n  content: \"\\e180\";\n}\n.icon_Notificationsolid:before {\n  content: \"\\e181\";\n}\n.icon_parkcall:before {\n  content: \"\\e182\";\n}\n.icon_parkcallfill:before {\n  content: \"\\e183\";\n}\n.icon_receiverfill:before {\n  content: \"\\e184\";\n}\n.icon_recordoutline:before {\n  content: \"\\e185\";\n}\n.icon_recordoutlinefill:before {\n  content: \"\\e186\";\n}\n.icon_summary:before {\n  content: \"\\e187\";\n}\n.icon_transcribe:before {\n  content: \"\\e188\";\n}\n.icon_transfer-fill:before {\n  content: \"\\e189\";\n}\n.icon_transferoutline:before {\n  content: \"\\e18a\";\n}\n.icon_transscript:before {\n  content: \"\\e18b\";\n}\n.icon_Unmute:before {\n  content: \"\\e18c\";\n}\n.icon_popout:before {\n  content: \"\\e18d\";\n}\n.icon_popin:before {\n  content: \"\\e18e\";\n}\n.icon_expandarrow:before {\n  content: \"\\e18f\";\n}\n.icon_Recordcalls:before {\n  content: \"\\e190\";\n}\n.icon_Newdoc:before {\n  content: \"\\e191\";\n}\n.icon_copydoc:before {\n  content: \"\\e192\";\n}\n.icon_stop:before {\n  content: \"\\e193\";\n}\n.icon_timer:before {\n  content: \"\\e194\";\n}\n.icon_Calendar:before {\n  content: \"\\e195\";\n}\n.icon_Home:before {\n  content: \"\\e196\";\n}\n.icon_Lockoutline:before {\n  content: \"\\e197\";\n}\n.icon_Message-outline:before {\n  content: \"\\e198\";\n}\n.icon_Natural:before {\n  content: \"\\e199\";\n}\n.icon_Profile-group:before {\n  content: \"\\e19a\";\n}\n.icon_Profile-outline:before {\n  content: \"\\e19b\";\n}\n.icon_Van:before {\n  content: \"\\e19c\";\n}\n.icon_Password:before {\n  content: \"\\e19d\";\n}\n.icon_Viewpassword:before {\n  content: \"\\e19e\";\n}\n.icon_Volume:before {\n  content: \"\\e19f\";\n}\n.icon_Volumemax:before {\n  content: \"\\e1a0\";\n}\n.icon_profileupload:before {\n  content: \"\\e1a1\";\n}\n.icon_Like:before {\n  content: \"\\e1a2\";\n}\n.icon_uparrow:before {\n  content: \"\\e1a3\";\n}\n.icon_callfill:before {\n  content: \"\\e1a4\";\n}\n.icon_filter:before {\n  content: \"\\e1a5\";\n}\n.icon_translation:before {\n  content: \"\\e1a6\";\n}\n.icon_location:before {\n  content: \"\\e1a7\";\n}\n.icon_listview:before {\n  content: \"\\e1a8\";\n}\n.icon_minimize:before {\n  content: \"\\e1a9\";\n}\n.icon_Bulletsquare:before {\n  content: \"\\e1aa\";\n}\n.icon_Fillpassword:before {\n  content: \"\\e1ab\";\n}\n.icon_sortup:before {\n  content: \"\\e1ac\";\n}\n.icon_User-outline:before {\n  content: \"\\e1ad\";\n}\n.icon_addcalander:before {\n  content: \"\\e1ae\";\n}\n.icon_sortdown:before {\n  content: \"\\e1af\";\n}\n.icon_Script:before {\n  content: \"\\e1b0\";\n}\n.icon_failedfill:before {\n  content: \"\\e1b1\";\n}\n.icon_primarymeet:before {\n  content: \"\\e1b2\";\n}\n.icon_Callfill2:before {\n  content: \"\\e1b3\";\n}\n.icon_Profileselect:before {\n  content: \"\\e1b4\";\n}\n.icon_profile-outline:before {\n  content: \"\\e1b5\";\n}\n.icon_notificationnew:before {\n  content: \"\\e1b6\";\n}\n.icon_singleclick:before {\n  content: \"\\e1b7\";\n}\n.icon_globe:before {\n  content: \"\\e1b8\";\n}\n.icon_app:before {\n  content: \"\\e1b9\";\n}\n.icon_profilestamp:before {\n  content: \"\\e1ba\";\n}\n.icon_mikeoutline:before {\n  content: \"\\e1bb\";\n}\n.icon_downarrow:before {\n  content: \"\\e1bc\";\n}\n.icon_recordleftpanel:before {\n  content: \"\\e1bd\";\n}\n.icon_transcript:before {\n  content: \"\\e1be\";\n}\n.icon_transcriptactive:before {\n  content: \"\\e1bf\";\n}\n.icon_chatdashboard:before {\n  content: \"\\e1c0\";\n}\n.icon_receiverdial:before {\n  content: \"\\e1c1\";\n}\n.icon_dialplus:before {\n  content: \"\\e1c2\";\n}\n.icon_unarchivefull:before {\n  content: \"\\e1c3\";\n}\n.icon_unsaved:before {\n  content: \"\\e1c4\";\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
